
$( document ).ready(function() {
    $('.bb--dropdown').on('click', function(){
        if($(this).hasClass('_active')){
            $(this).removeClass('_active');
            $('.a_b-brands').removeClass('open');
            $('.a_b-brands').slideUp();
        }else{
            $(this).addClass('_active');
            $('.a_b-brands').addClass('open');
            $('.a_b-brands').slideDown();
        }
    });



});